import React, { FC } from 'react';

export const CurrentPrice: FC<{
  formattedCurrentPrice: string;
  reductionPercentage: number;
  style: {
    fontSize: string;
    marginBottom: string;
  };
}> = ({ formattedCurrentPrice, reductionPercentage, style }) => {
  return (
    <div className="current-price">
      {formattedCurrentPrice}
      <style jsx>{`
        .current-price {
          color: ${reductionPercentage && reductionPercentage !== 0 ? '#F25C5E' : '#000'};
          font-size: ${style.fontSize};
          margin-bottom: ${style.marginBottom};
          line-height: 1;
        }
      `}</style>
    </div>
  );
};
